import React, { useEffect, useRef, useState } from 'react'
import Menu from '../Menu'
import { useIsVisible } from '../../hooks/useIsVisible'
import Toggle from '../Toggle'
import { useDarkMode } from '../DarkModeProvider'
import { Link } from 'gatsby'
import { useContactForm } from '../ContactFormProvider'

export default function Header() {
  const { isDarkMode, toggleDarkMode } = useDarkMode()
  const [showMenu, setShowMenu] = useState(false)
  const [scroll, setScroll] = useState(false)
  const [fullScreen, setFullScreen] = useState(true)
  const [showLogo, setShowLogo] = useState(false)
  const { setShowContactForm } = useContactForm()

  const navRef = useRef<HTMLDivElement>(null)
  const navIsVisible = useIsVisible(navRef)

  useEffect(() => {
    setTimeout(() => {
      setFullScreen(false)
    }, 2000)
    setTimeout(() => {
      setShowLogo(true)
    }, 3000)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY > 0)
    }

    handleScroll()

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <nav
        ref={navRef}
        className={`fixed top-0 left-0 w-full flex flex-row justify-between items-center px-6 sm:px-12 py-6 z-40 transition-all duration-1000 ease-[cubic-bezier(0.1,0.15,0.15,1)] ${fullScreen ? 'bg-black h-screen' : scroll ? 'bg-black/60 dark:bg-white/30 backdrop-blur-2xl h-[76px]' : 'h-[76px] bg-transparent backdrop-blur-0'}`}
      >
        {!fullScreen && (
          <button
            className={`font-serif text-white text-lg [transition:margin_1s,opacity_1s,color_.3s] hover:text-neutral-300 ${navIsVisible ? 'opacity-100 ml-0 mr-0' : 'opacity-0 ml-6 -mr-6'}`}
            onClick={() => setShowMenu(true)}
          >
            Menu
          </button>
        )}
        {!fullScreen && (
          <div className="flex gap-6 items-center">
            <button
              className={`font-serif text-white text-lg [transition:margin_1s,opacity_1s,color_.3s] hover:text-neutral-300 ${navIsVisible ? 'opacity-100 ml-0 mr-0' : 'opacity-0 -ml-6 mr-6'}`}
              onClick={() => setShowContactForm(true)}
            >
              Contacto
            </button>
            <Toggle value={isDarkMode} onChange={toggleDarkMode} />
          </div>
        )}
        <Menu show={showMenu} onClose={() => setShowMenu(false)} />
      </nav>
      <Link
        to={fullScreen ? '' : '/'}
        className={`relative ${fullScreen ? 'cursor-auto' : 'cursor-pointer'}`}
      >
        {!fullScreen && (
          <img
            src="/images/DA_logo.svg"
            alt="Distrito Álamos"
            className={`fixed z-50 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-300 ease-[cubic-bezier(0.1,0.15,0.15,1)] w-[120px] sm:w-[180px] top-6 sm:top-4 ${showLogo ? 'opacity-100' : 'opacity-0'}`}
          />
        )}
        <img
          src="/images/DA_icon.svg"
          alt="Distrito Álamos"
          className={`fixed z-50 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-300 ease-[cubic-bezier(0.1,0.15,0.15,1)] ${navIsVisible ? 'opacity-100 mt-0 mb-0' : 'opacity-0 mt-6 -mb-6'} ${fullScreen ? 'w-2/3 top-1/2 -translate-y-1/2' : 'w-[120px] sm:w-[180px] top-6 sm:top-4 translate-y-0'}`}
        />
      </Link>
    </>
  )
}
